
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2qdw9_1awhj_5",
  "root-no-actions": "awsui_root-no-actions_2qdw9_1awhj_19",
  "root-variant-h1": "awsui_root-variant-h1_2qdw9_1awhj_19",
  "root-variant-h1-refresh": "awsui_root-variant-h1-refresh_2qdw9_1awhj_22",
  "root-variant-h2": "awsui_root-variant-h2_2qdw9_1awhj_25",
  "root-has-description": "awsui_root-has-description_2qdw9_1awhj_25",
  "root-variant-h2-refresh": "awsui_root-variant-h2-refresh_2qdw9_1awhj_28",
  "root-variant-h3": "awsui_root-variant-h3_2qdw9_1awhj_31",
  "root-variant-h3-refresh": "awsui_root-variant-h3-refresh_2qdw9_1awhj_34",
  "root-no-wrap": "awsui_root-no-wrap_2qdw9_1awhj_37",
  "main": "awsui_main_2qdw9_1awhj_41",
  "main-variant-h1": "awsui_main-variant-h1_2qdw9_1awhj_49",
  "main-variant-h1-refresh": "awsui_main-variant-h1-refresh_2qdw9_1awhj_52",
  "main-variant-h2": "awsui_main-variant-h2_2qdw9_1awhj_58",
  "main-variant-h3": "awsui_main-variant-h3_2qdw9_1awhj_58",
  "main-variant-h2-refresh": "awsui_main-variant-h2-refresh_2qdw9_1awhj_64",
  "actions": "awsui_actions_2qdw9_1awhj_71",
  "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_1awhj_75",
  "actions-variant-h1-refresh": "awsui_actions-variant-h1-refresh_2qdw9_1awhj_78",
  "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_1awhj_81",
  "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_1awhj_81",
  "actions-variant-h2-refresh": "awsui_actions-variant-h2-refresh_2qdw9_1awhj_87",
  "actions-variant-h3-refresh": "awsui_actions-variant-h3-refresh_2qdw9_1awhj_90",
  "title": "awsui_title_2qdw9_1awhj_94",
  "title-variant-h2": "awsui_title-variant-h2_2qdw9_1awhj_100",
  "title-variant-h3": "awsui_title-variant-h3_2qdw9_1awhj_100",
  "title-variant-h2-refresh": "awsui_title-variant-h2-refresh_2qdw9_1awhj_109",
  "info": "awsui_info_2qdw9_1awhj_119",
  "description": "awsui_description_2qdw9_1awhj_123",
  "description-variant-h1": "awsui_description-variant-h1_2qdw9_1awhj_128",
  "description-variant-h1-refresh": "awsui_description-variant-h1-refresh_2qdw9_1awhj_133",
  "description-variant-h2": "awsui_description-variant-h2_2qdw9_1awhj_136",
  "description-variant-h3": "awsui_description-variant-h3_2qdw9_1awhj_141",
  "description-variant-h3-refresh": "awsui_description-variant-h3-refresh_2qdw9_1awhj_147",
  "heading": "awsui_heading_2qdw9_1awhj_151",
  "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_1awhj_160",
  "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_1awhj_166",
  "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_1awhj_169",
  "heading-text": "awsui_heading-text_2qdw9_1awhj_173",
  "counter": "awsui_counter_2qdw9_1awhj_177"
};
  